/**
 * PDP Translations
 *
 * Camada extra de tradução que roda em cima do app de tradução nativo.
 * Carrega em todas as páginas (ver theme.liquid) e só roda quando o
 * subdomínio `espanol.` está ativo (ex.: espanol.thefleececompany.com).
 * Cobre as sobras que o app nativo não pega: PDP, widgets de apps
 * (Judge.me, Kaching) e o mini-cart.
 *
 * Tipos de regra:
 *  - TEXT_RULES:      substitui o textContent inteiro de um elemento.
 *                     Use quando o elemento NÃO tem filhos a preservar.
 *  - TEXT_NODE_RULES: roda regex nos text nodes diretos do elemento,
 *                     preservando filhos (ex.: spans de acessibilidade).
 *  - CSS_RULES:       sobrescreve `content` de pseudo-elementos
 *                     (::before / ::after) via <style> injetado.
 */
(function () {
  'use strict';

  if (!/^espanol\./i.test(window.location.hostname)) return;

  // Reaproveitados em mais de um bloco (Kaching na PDP + mini-cart).
  // BUNDLE_TITLE: "Buy N, get N free!" para qualquer número.
  var BUNDLE_TITLE = [/Buy\s+(\d+),\s*get\s+(\d+)\s+free!/i, '¡Compra $1 y llévate $2 gratis!'];

  // VARIANT_VALUES: cores (regex ancorado p/ casar o nome inteiro e não
  // pegar pedaço dentro de "Limited Edition: Baby Blue") + a unidade de
  // tamanho "in" -> "pulgadas". Mantém Full/Queen/King no original.
  var VARIANT_VALUES = [
    [/^\s*Dune\s*$/i, 'Duna'],
    [/^\s*Green\s*$/i, 'Verde'],
    [/^\s*Blue\s*$/i, 'Azul'],
    [/^\s*Pink\s*$/i, 'Rosa'],
    [/^\s*White\s*$/i, 'Blanco'],
    [/^\s*Grey\s*$/i, 'Gris'],
    [/^\s*Black\s*$/i, 'Negro'],
    [/^\s*Wine Red\s*$/i, 'Rojo Vino'],
    [/^\s*Purple\s*$/i, 'Morado'],
    [/^\s*Limited Edition:\s*Baby Blue\s*$/i, 'Edición Limitada: Azul Bebé'],
    [/^\s*Limited Edition:\s*Rust Brown\s*$/i, 'Edición Limitada: Marrón Óxido'],
    [/^\s*Limited Edition:\s*Peach\s*$/i, 'Edición Limitada: Melocotón'],
    [/(\d+\s*x\s*\d+)\s*in\b/i, '$1 pulgadas']
  ];

  var TEXT_RULES = [
    // { selector: '...', to: '...' }
  ];

  var TEXT_NODE_RULES = [
    // Variant size labels (Queen 60x80, King 80x90 in, King XL 95 x 105 cm.):
    // o tema usa polegadas; o auto-tradutor às vezes deixa "cm", "in",
    // "inches" ou pontuação solta. Normaliza tudo para "<dimensão> pulgadas"
    // e remove pontuação órfã que sobra fora do span de acessibilidade.
    {
      selector: 'label',
      contains: '.label-unavailable',
      replacements: [
        [/(\d+\s*x\s*\d+)\s*(?:cm|in(?:ch(?:es)?)?|pulg(?:adas?)?)?\b\s*[:.]?\s*$/i, '$1 pulgadas'],
        [/^\s*[.:]\s*$/, '']
      ]
    },
    // Judge.me badge: "6025 reviews" -> "6025 reseñas" (plural / singular).
    // Carregado pelo script do Judge.me, então depende do MutationObserver.
    {
      selector: '.jdgm-prev-badge__text',
      replacements: [
        [/\breviews\b/gi, 'reseñas'],
        [/\breview\b/gi, 'reseña']
      ]
    },

    // -----------------------------------------------------------------
    // Kaching Bundles (app de bundles na PDP).
    // É um app Vue, então cada elemento traz comentários `<!---->` como
    // âncoras de render. Por isso usamos TEXT_NODE_RULES (mexe só nos
    // text nodes diretos) em vez de TEXT_RULES — assim preservamos as
    // âncoras e nunca tocamos em `value`/`data-value` (carrinho intacto).
    // O conteúdo é injetado/re-renderizado em runtime, então depende do
    // MutationObserver.
    // -----------------------------------------------------------------

    // Título do bloco da promoção.
    {
      selector: '.kaching-bundles__block-title',
      replacements: [
        [/EARLY\s+SUMMER\s+SALE/i, 'REBAJAS DE PRINCIPIOS DE VERANO']
      ]
    },
    // Título da barra: "Buy N, get N free!" (genérico p/ qualquer número).
    {
      selector: '.kaching-bundles__bar-title',
      replacements: [BUNDLE_TITLE]
    },
    // Subtítulo da barra: singular x plural ("Blanket" / "Blankets").
    {
      selector: '.kaching-bundles__bar-subtitle',
      replacements: [
        [/Get\s+1\s+Free\s+Blanket!/i, '¡Llévate 1 manta gratis!'],
        [/Get\s+(\d+)\s+Free\s+Blankets!/i, '¡Llévate $1 mantas gratis!']
      ]
    },
    // Selo "mais vendido".
    {
      selector: '.kaching-bundles__bar-most-popular__content',
      replacements: [
        [/Bestseller/i, 'Más vendido']
      ]
    },
    // Cabeçalhos das variantes ("Color" / "Size"). "Color" é igual em
    // espanhol, então só "Size" precisa mudar.
    {
      selector: '.kaching-bundles__bar-variant-names span',
      replacements: [
        [/^\s*Size\s*$/i, 'Tamaño']
      ]
    },
    // Valores das variantes (cores e tamanhos) dentro de cada <option>.
    {
      selector: '.kaching-bundles-option-value',
      replacements: VARIANT_VALUES
    },

    // Badge "Only available here / don't buy / fakes on Amazon" na PDP.
    // Cada pedaço vive no seu próprio <span> (bold/regular/italic) — uma
    // regra por span preserva a formatação.
    {
      selector: '.badge-container .text-bold',
      replacements: [
        [/Only available here/i, 'Solo disponible aquí']
      ]
    },
    {
      selector: '.badge-container .text-regular',
      replacements: [
        [/don['’]?t buy/i, 'no compres']
      ]
    },
    {
      selector: '.badge-container .text-italic',
      replacements: [
        [/fakes on Amazon/i, 'falsificaciones en Amazon']
      ]
    },

    // -----------------------------------------------------------------
    // Mini-cart (gaveta do carrinho). Aparece em todas as páginas — por
    // isso o script agora carrega no site inteiro (ver theme.liquid).
    // É re-renderizado via fetch (?section_id=mini-cart), então depende
    // do MutationObserver. Mexemos só em texto visível.
    // -----------------------------------------------------------------

    // Título: "Your Cart (N)".
    {
      selector: '.mini-cart__header .title',
      replacements: [
        [/Your Cart\s*\((\d+)\)/i, 'Tu carrito ($1)'],
        [/^\s*Your Cart\s*$/i, 'Tu carrito']
      ]
    },
    // Banner de urgência (preserva o <span> do contador).
    {
      selector: '.timer-banner',
      replacements: [
        [/Stock is low\s*\|\s*Your cart is reserved for/i, 'Las existencias son limitadas | Tu carrito está reservado por']
      ]
    },
    // Estado vazio.
    {
      selector: '.mini-cart__empty-text',
      replacements: [
        [/Your cart is currently empty/i, 'Tu carrito está vacío']
      ]
    },
    {
      selector: '.mini-cart__empty-message p',
      replacements: [
        [/Not sure where to start\?/i, '¿No sabes por dónde empezar?'],
        [/Try these brands:/i, 'Prueba estas marcas:']
      ]
    },
    {
      selector: '.mini-cart__empty .button',
      replacements: [
        [/Return to shop/i, 'Volver a la tienda']
      ]
    },
    // Linha de economia: "(You Save $X)" (o texto está num <strong> filho).
    {
      selector: '.price-save strong',
      replacements: [
        [/\(You Save\s+(.+?)\)/i, '(Ahorras $1)']
      ]
    },
    // Rótulos das variantes no carrinho ("Color:" / "Size:").
    {
      selector: '.cart-drawer__option-row dt',
      replacements: [
        [/^\s*Size:\s*$/i, 'Tamaño:']
      ]
    },
    // Valores das variantes no carrinho (mesmo mapa do Kaching).
    {
      selector: '.cart-drawer__option-row dd',
      replacements: VARIANT_VALUES
    },
    // Botão remover.
    {
      selector: '.delete-product',
      replacements: [
        [/\bRemove\b/i, 'Eliminar']
      ]
    },
    // Label de desconto no item ("Buy N, get N free!").
    {
      selector: '.discounts__discount',
      replacements: [BUNDLE_TITLE]
    },
    // Nota de impostos: preserva o link de shipping. Traduz os pedaços
    // ao redor (no <small>) e o texto do link separadamente; em espanhol
    // fica "Impuestos, descuentos y [envío] se calculan al finalizar...".
    {
      selector: '.tax-note',
      replacements: [
        [/Taxes, discounts and/i, 'Impuestos, descuentos y'],
        [/calculated at checkout\./i, 'se calculan al finalizar la compra.']
      ]
    },
    {
      selector: '.tax-note a',
      replacements: [
        [/shipping/i, 'envío']
      ]
    },
    // Rodapé. "Subtotal" é igual em espanhol, então fica de fora.
    {
      selector: '.text-save-d5',
      replacements: [
        [/Savings/i, 'Ahorros']
      ]
    },
    {
      selector: '.checkout-btn-d5',
      replacements: [
        [/Continue to Checkout/i, 'Continuar al pago']
      ]
    },
    {
      selector: '.cd-trust-badge-d5 p',
      replacements: [
        [/100-DAY SATISFACTION GUARANTEE/i, 'GARANTÍA DE SATISFACCIÓN DE 100 DÍAS']
      ]
    },
    // Nome do produto — mapeado por produto, a pedido. O título vem do
    // Shopify; se o app nativo já traduzir, esta regra fica redundante.
    // Casa só o nome (o sufixo "(B1G1)" e similares ficam intactos).
    // A11y (aria-label / spans visually-hidden) permanece em inglês.
    {
      selector: '.product-title',
      replacements: [
        [/The New Winter Muslin Blanket - 100% Muslin Cotton/i, 'La Nueva Manta de Muselina de Invierno - 100% Algodón de Muselina']
      ]
    }
  ];

  var CSS_RULES = [
    { selector: '.jdgm-rev__buyer-badge::before', content: 'Verificado' }
  ];

  // Retorna o próprio root (se casar) + descendentes que casam.
  // querySelectorAll sozinho não inclui o root, então quando o
  // MutationObserver entrega um <label> direto, o seletor 'label'
  // não casaria nada — daí a checagem com matches() aqui.
  function findMatches(root, selector) {
    var scope = root || document;
    var list = [];
    if (root && root.nodeType === 1 && root.matches && root.matches(selector)) {
      list.push(root);
    }
    if (scope.querySelectorAll) {
      var descendants = scope.querySelectorAll(selector);
      for (var i = 0; i < descendants.length; i++) list.push(descendants[i]);
    }
    return list;
  }

  function applyTextRule(rule, root) {
    var nodes = findMatches(root, rule.selector);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].textContent !== rule.to) {
        nodes[i].textContent = rule.to;
      }
    }
  }

  function applyTextNodeRule(rule, root) {
    var matches = findMatches(root, rule.selector);
    for (var i = 0; i < matches.length; i++) {
      var el = matches[i];
      if (rule.contains && !el.querySelector(rule.contains)) continue;
      var children = el.childNodes;
      for (var k = 0; k < children.length; k++) {
        var node = children[k];
        if (node.nodeType !== 3) continue;
        var original = node.nodeValue;
        var updated = original;
        for (var r = 0; r < rule.replacements.length; r++) {
          updated = updated.replace(rule.replacements[r][0], rule.replacements[r][1]);
        }
        if (updated !== original) node.nodeValue = updated;
      }
    }
  }

  // -----------------------------------------------------------------
  // Preço cheio do Kaching ("($200.00 Value)").
  // Este elemento NÃO pode ter o texto editado: o app policia o formato
  // e re-embrulha o conteúdo atual com "(… Value)" sempre que o texto
  // deixa de casar — editar o texto gerou o "((Valor de $200.00) Value)"
  // aninhado e, com regra que casava o re-embrulho, o loop infinito que
  // congelou a PDP. Estratégia: nunca tocar no texto. A tradução vai num
  // atributo (data-precio-es) e aparece via CSS (font-size:0 no texto
  // real + ::after com content:attr()). O Kaching segue vendo o texto
  // inglês dele intacto; sem o atributo, o elemento mostra o inglês
  // normalmente (fallback seguro).
  // -----------------------------------------------------------------
  var FULL_PRICE_SEL = '.kaching-bundles__bar-full-price';
  // O Kaching também escreve o "(… Value)" no compare do bloco de preço do
  // TEMA (sync de preço do app) — mesmo tratamento de gêmeo. O gate de
  // padrão abaixo garante que compares normais (cards, valores puros como
  // "$276.00") nunca sejam tocados.
  var THEME_COMPARE_SEL = '.price__sale s.price-item--regular';
  var FULL_PRICE_RE = /\(\s*([^()]*\d[^()]*?)\s*Value\s*\)/i;
  var TWIN_CLASS = 'pdp-precio-es';

  // Extrai o valor monetário mesmo de texto aninhado
  // ("((Valor de $138.00) Value)" -> "$138.00").
  function extractFullPriceMoney(text) {
    var m = (text || '').match(/(?:US\$|AU\$|CA\$|NZ\$|R\$|A\$|\$|€|£)\s?\d[\d.,]*/);
    return m ? m[0].trim() : '';
  }

  // tagName: 'span' na barra; 's' no compare do tema (mantém o riscado).
  function mirrorValueEl(el, tagName) {
    var text = el.textContent;
    if (!FULL_PRICE_RE.test(text) && text.indexOf('Valor') === -1) return;
    var money = extractFullPriceMoney(text);
    if (!money) return;
    var label = '(Valor de ' + money + ')';

    var twin = el.nextElementSibling;
    if (!twin || !twin.classList || !twin.classList.contains(TWIN_CLASS)) {
      if (!document.documentElement.contains(el) || !el.parentNode) return;
      var cs = window.getComputedStyle(el);
      if (!parseFloat(cs.fontSize)) return; // sem medida confiável, não mexe
      twin = document.createElement(tagName);
      twin.className = TWIN_CLASS;
      twin.setAttribute('data-wg-notranslate', 'true');
      twin.style.fontSize = cs.fontSize;
      twin.style.fontWeight = cs.fontWeight;
      twin.style.color = cs.color;
      el.parentNode.insertBefore(twin, el.nextSibling);
    }
    if (twin.textContent !== label) twin.textContent = label;

    if (twin.offsetWidth > 0) {
      // Gêmeo comprovadamente renderizado — só agora escondemos o original.
      if (el.style.display !== 'none') el.style.setProperty('display', 'none', 'important');
    } else if (twin.parentNode) {
      // Gêmeo não renderizou (container oculto etc.) — remove e mantém o
      // inglês visível. Nunca esconder o original sem substituto na tela.
      twin.parentNode.removeChild(twin);
    }
  }

  function mirrorFullPrice(root) {
    var bars = findMatches(root, FULL_PRICE_SEL);
    for (var i = 0; i < bars.length; i++) mirrorValueEl(bars[i], 'span');
    var compares = findMatches(root, THEME_COMPARE_SEL);
    for (var k = 0; k < compares.length; k++) mirrorValueEl(compares[k], 's');
  }

  function applyAll(root) {
    for (var i = 0; i < TEXT_RULES.length; i++) applyTextRule(TEXT_RULES[i], root);
    for (var j = 0; j < TEXT_NODE_RULES.length; j++) applyTextNodeRule(TEXT_NODE_RULES[j], root);
    mirrorFullPrice(root);
  }

  function injectCssRules() {
    if (!CSS_RULES.length) return;
    var css = '';
    for (var i = 0; i < CSS_RULES.length; i++) {
      var r = CSS_RULES[i];
      css += r.selector + '{content:"' + r.content.replace(/"/g, '\\"') + '" !important;}';
    }
    var style = document.createElement('style');
    style.setAttribute('data-pdp-translations', '');
    style.textContent = css;
    (document.head || document.documentElement).appendChild(style);
  }

  function init() {
    injectCssRules();
    applyAll();

    if (!TEXT_RULES.length && !TEXT_NODE_RULES.length) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType === 1) applyAll(node);
          else if (node.nodeType === 3 && node.parentNode) applyAll(node.parentNode);
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
